/**
 * @generated SignedSource<<49f2cb0cedfb1093f04282156c2fb602>>
 * @relayHash a5ed50647af6fea569a4ab5e15cf4bc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbaac5fcdb270257646cf6f81e98aeb8be228c55e4f34c33e0db24a5e84cb98a

import type { ConcreteRequest } from 'relay-runtime';
export type HomeWidgetState = "COLLAPSED" | "EXPANDED" | "%future added value";
export type useHomeWidgetStateHomeWidgetsMutation$variables = {
  id: string;
  state: HomeWidgetState;
};
export type useHomeWidgetStateHomeWidgetsMutation$data = {
  readonly updateUserPreferences: {
    readonly homeWidgets: ReadonlyArray<{
      readonly id: string;
      readonly state: HomeWidgetState;
    }>;
  } | null;
};
export type useHomeWidgetStateHomeWidgetsMutation = {
  response: useHomeWidgetStateHomeWidgetsMutation$data;
  variables: useHomeWidgetStateHomeWidgetsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "state"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "state",
                "variableName": "state"
              }
            ],
            "kind": "ObjectValue",
            "name": "homeWidget"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "HomeWidget",
        "kind": "LinkedField",
        "name": "homeWidgets",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "state"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHomeWidgetStateHomeWidgetsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHomeWidgetStateHomeWidgetsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5ed50647af6fea569a4ab5e15cf4bc1",
    "id": "bbaac5fcdb270257646cf6f81e98aeb8be228c55e4f34c33e0db24a5e84cb98a",
    "metadata": {},
    "name": "useHomeWidgetStateHomeWidgetsMutation",
    "operationKind": "mutation",
    "text": "mutation useHomeWidgetStateHomeWidgetsMutation($id:ID!,$state:HomeWidgetState!){updateUserPreferences(userPreferences:{homeWidget:{id:$id,state:$state}}){homeWidgets{id,state}}}"
  }
};
})();

(node as any).hash = "5471258689abf3a3cbbbc72377571311";

export default node;
